import { useContext } from 'react';
import styled from "styled-components";
import { StringTable } from '../localization/StringTableTypes';
import { StringsContext } from '../localization/StringsContext';

const getVictoryText = (strings: StringTable, winner: number): string => {
    switch (winner) {
        case 1: return strings.result.won;
        case 2: return strings.result.lose;
        default: return strings.result.draw;
    }
}

type PropsType = {
    winner: number,
    onResetClick: () => void
}

export default ({ winner, onResetClick }: PropsType): JSX.Element => {
    const strings = useContext(StringsContext);
    
    if (winner === 0) {
        return (
            <HeaderWrapper>
                <HeaderTitle>{strings.title}</HeaderTitle>
                <RestartButton onClick={onResetClick} />
            </HeaderWrapper>
        );
    } else {
        return (
            <HeaderWrapperWinner>
                {getVictoryText(strings, winner)} <LinkButton onClick={() => onResetClick()}>{strings.result.newGame}</LinkButton>
            </HeaderWrapperWinner>
        );
    }
}

const HEADER_HEIGHT = 26;
const HeaderWrapper = styled.div`
    font-size: 26px;
    height: ${HEADER_HEIGHT}px;
    line-height: ${HEADER_HEIGHT}px;
    margin: 0 0 20px 0;
`

const HeaderTitle = styled.div`
    float: left;
`;

const BUTTON_PADDING = 6;
const RestartButton = styled.button`
    $size: 26px;
    $btn-padding: 6px;

    display: inline;
    width: ${HEADER_HEIGHT}px;
    height: ${HEADER_HEIGHT}px;
    margin: 0;
    padding: 4px;
    float: right;
    background: transparent url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M347 17c-16-6-35 2-41 18c-6 17 2 35 18 41C398 105 448 177 448 256c0 106-86 192-192 192C150 448 64 362 64 256c0-54 23-104 61-140l55 55C184 174 188 176 192 176c2 0 4-0 6-1C204 172 208 166 208 160V16c0-9-7-16-16-16H48C42 0 36 4 33 10c-2 6-1 13 3 17l43 43C30 118 0 185 0 256c0 141 115 256 256 256s256-115 256-256C512 151 446 55 347 17z'/></svg>");
    background-size: ${HEADER_HEIGHT - BUTTON_PADDING * 2}px ${HEADER_HEIGHT - BUTTON_PADDING * 2}px;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid black;
    border-radius: ${HEADER_HEIGHT / 3}px;
    cursor: pointer;
    filter: invert(0.3);

    @media (pointer: fine) {
        &:hover, &:active {
            filter: invert(0);
        }
    }
`;

const HeaderWrapperWinner = styled(HeaderWrapper)`
    @media (max-width: 767px) {
        font-size: 20px;
    }
    text-align: center;
`;

const LinkButton = styled.button`
    display: inline;
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    font: inherit;
    cursor: pointer;
    text-decoration: underline;
    
    &:hover, &:active {
        color: #0000BB;
        text-decoration: none;
    }
`